const cache = {};

export function playSound(name) {
    if (!cache[name]) {
        cache[name] = new Audio(`${process.env.PUBLIC_URL}/sounds/${name}.mp3`);
    }
    const audio = cache[name];
    audio.currentTime = 0;
    audio.play().catch(() => {});
}

const CHUCKLE_PATTERNS = [
    { re: /\bheh+\b|\bhehe+\b/i,      sound: 'chuckle1' },
    { re: /\bhah+\b|\bhaha+\b/i,      sound: ['chuckle2', 'chuckle5'] },
    { re: /\blol+\b/i,                 sound: 'chuckle3' },
    { re: /\blmfao\b|\blmao\b|\brofl(?:mao)?\b/i, sound: ['chuckle4', 'chuckle6'] },
];

function hashStr(s) {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    return Math.abs(h);
}

function pickSound(sound, text) {
    return Array.isArray(sound) ? sound[hashStr(text) % sound.length] : sound;
}

export function playChuckleIfMatch(text) {
    for (const { re, sound } of CHUCKLE_PATTERNS) {
        if (re.test(text)) { playSound(pickSound(sound, text)); return; }
    }
}
